import React from 'react';
import { Label } from '../Label';
export const BlackFridayLabel = () => React.createElement(Label, { backgroundColor: "gray1000" }, "Black Friday Week");
